module.exports = __webpack_public_path__ + "img/login-laptop-screen.3e2672b2.png";